import { Card } from "primereact/card"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { useContext, useState } from "react"
import { useQuery, gql } from "@apollo/client"
import { LoaderMedium } from "../../../components/Loaders"
import { Dropdown } from "primereact/dropdown"
import { useFormik } from "formik"
import { useEffect } from "react"
import { endpoints } from "../../../config/gpraApiEndpoints"
import axios from "axios"
import { gpraUrl } from "../../../config/microservicesUrls"
import { Toast } from "primereact/toast"
import { useRef } from "react"
import Warning from "./Warning"
import { Checkbox } from "primereact/checkbox"
import { daysRestriction } from "../types/warningMessages"
import { Link } from "react-router-dom"
import { RELOAD_TYPES } from "../types/interviewTypes"
import { showMessage } from "../utils/utils"
import { UserContext } from "../../../context/userContext"

const GpraNotElegible = ({
  staff_id,
  organization_id,
  participant_uuid,
  participant_id,
  membership_uuid,
  organization_alias,
  participant_name,
  organization_name,
  setReloadStatus,
  programs_list,
  inactiveParticipant,
  message,
}) => {
  const [showDialog, setShowDialog] = useState(false)
  const [programs, setPrograms] = useState([])
  const [restrictions, setRestrictions] = useState(false)
  const [loading, setLoading] = useState(false)
  const [warning, setWarning] = useState(false)
  const [cancelRestriction, setCancelRestriction] = useState()

  const userCtx = useContext(UserContext)

  const toast = useRef()

  const formik = useFormik({
    initialValues: {
      program: "",
    },
    validate: (data) => {
      let errors = {}
      if (!data.program) {
        errors.program = "Program is required"
      }
      return errors
    },
    onSubmit: (data) => {
      createGpraRecord(data)
      formik.resetForm()
    },
  })

  useEffect(() => {
    setLoading(true)
    if (participant_uuid && membership_uuid) {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
        params: { participant_uuid, membership_uuid },
      }
      axios
        .get(`${gpraUrl()}${endpoints.GET_DAYS_RESTRICTION}`, config)
        .then((response) => {
          if (response.status === 200) {
            setRestrictions(response.data)
            setWarning(response.data)
          }
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
          showMessage(false, "Unable to get days restriction", toast)
        })
    }
  }, [membership_uuid, participant_uuid])

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name])

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    )
  }

  const createGpraRecord = (data) => {
    const config = {
      headers: {
        Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
      },
    }
    axios
      .put(
        `${gpraUrl()}${endpoints.CREATE_GPRA_RECORD}`,
        {
          gpra_participant_uuid: participant_uuid,
          gpra_participant_id: participant_id,
          gpra_program_id: data.program,
          gpra_organization_id: organization_alias,
          gpra_organization_uuid: organization_id,
          gpra_membership_uuid: membership_uuid,
          gpra_created_by: staff_id,
        },
        config,
      )
      .then((response) => {
        if (response.status === 201) {
          setShowDialog(false)
          showMessage(true, "Gpra Record successfully created", toast)
          formik.resetForm()
          setReloadStatus(RELOAD_TYPES.createRecord)
        }
      })
      .catch((err) => {
        console.log("err", err)
        setShowDialog(false)
        showMessage(false, "Unable to create Gpra Record", toast)
        formik.resetForm()
      })
  }

  const GET_PROGRAMS = gql`
    query Programs($staff_id: ID!, $organization_id: ID!) {
      programs(staff_id: $staff_id, organization_id: $organization_id) {
        program_identity_id
        program_id_name
        program_id_status
        program_id_create_date
        program_id_change_date
        organization_id
        organization_name
        program_id_gpra
      }
    }
  `
  const progQuery = useQuery(GET_PROGRAMS, {
    variables: { staff_id: staff_id, organization_id: organization_id },
    fetchPolicy: "network-only",
    onCompleted: ({ programs }) => {
      let active_programs = []
      if (programs && programs.length > 0) {
        active_programs = programs_list?.map((pl) => {
          const program_data = programs.find(
            (p) => p.program_id_name === pl && p.program_id_status === "ACTIVE",
          )
          return { label: pl, value: program_data?.program_identity_id }
        })
      }
      setPrograms(active_programs)
    },
    skip: !organization_id || !staff_id,
    onError: (error) => {
      console.log(error)
    },
  })
  return (
    <>
      <Toast ref={toast}></Toast>
      {progQuery.loading || loading ? (
        <LoaderMedium></LoaderMedium>
      ) : (
        <Card className={gpraStyles.card}>
          <div className="flex align-items-center justify-content-between mb-0 px-3 pb-0 mt-1">
            {inactiveParticipant ? (
              <p>
                <b>Participant is inactive, cannot create a new GPRA record</b>
              </p>
            ) : (
              message && (
                <p>
                  <b>
                    No current GPRA record found. Please create a new GPRA
                    record.
                  </b>
                </p>
              )
            )}
          </div>
          <Button
            label={"Create New GPRA Record"}
            className={gpraStyles.mt1}
            onClick={() => {
              setShowDialog(true)
            }}
            disabled={inactiveParticipant}
          />
          <Dialog
            header="Create New GPRA Record"
            visible={showDialog}
            onHide={() => {
              setShowDialog(false)
              formik.resetForm()
            }}
            style={{ width: "600px" }}
            modal
          >
            <form onSubmit={formik.handleSubmit}>
              <div
                style={{
                  marginBottom: "1rem",
                  marginTop: "1rem",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <label className={gpraStyles.label}>Participant:</label>
                <label
                  style={{ marginLeft: "1rem" }}
                  className={gpraStyles.subLabel}
                >
                  <i>{` ${participant_name}`}</i>
                </label>
              </div>
              <div
                style={{
                  marginBottom: "1rem",
                  marginTop: "1rem",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <label className={gpraStyles.label}>Organization:</label>
                <label
                  style={{ marginLeft: "1rem" }}
                  className={gpraStyles.subLabel}
                >
                  <i>{` ${organization_name}`}</i>
                </label>
              </div>
              <div style={{ marginBottom: "1rem" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <label
                    className={`${gpraStyles.label} ${gpraStyles.requiredField}`}
                    style={{ width: "5rem" }}
                  >
                    Program
                  </label>
                  <Dropdown
                    id="program"
                    options={programs}
                    optionLabel="label"
                    optionValue="value"
                    value={formik.values.program}
                    onChange={(e) => {
                      formik.setFieldValue("program", e.value)
                    }}
                    disabled={
                      !programs_list ||
                      programs_list?.length === 0 ||
                      programs.length === 0
                    }
                    style={{ marginTop: "0rem", marginLeft: "1rem" }}
                  />
                </div>
                {getFormErrorMessage("program")}
              </div>
              {(!programs_list ||
                programs_list.length === 0 ||
                programs.length === 0) && (
                <div style={{ marginBottom: "1rem" }}>
                  <span>
                    <i>
                      <b>Note:</b> No GPRA enabled Programs are assigned to the
                      participant, please visit{" "}
                      <Link
                        to={"/form/manage_services/1/"}
                        style={{ color: "blue" }}
                      >
                        Manage Services{" "}
                      </Link>
                      for Program assignment.
                    </i>
                  </span>
                </div>
              )}
              {warning && programs_list && programs_list?.length > 0 && (
                <div>
                  <Checkbox
                    checked={cancelRestriction}
                    onChange={(e) => {
                      setCancelRestriction(e.checked)
                    }}
                  />
                  <label className={gpraStyles.ml1}>
                    I acknowledge the 30-day restriction advisory but I choose
                    to continue anyway
                  </label>
                </div>
              )}

              <Button
                label="Create"
                type="submit"
                className={gpraStyles.mt1}
                disabled={
                  restrictions ||
                  (!cancelRestriction && warning) ||
                  programs?.length === 0
                }
              />
            </form>
          </Dialog>
          <Warning
            visible={warning}
            setVisible={setWarning}
            label={daysRestriction.label}
            type={daysRestriction.label}
          />
        </Card>
      )}
    </>
  )
}
export default GpraNotElegible
